<template>
  <div class="questionnaire-result">
    <slot />
  </div>
</template>

<script>
export default {
  provide() {
    return {
      solution: this.solution,
    };
  },
  props: {
    solution: {
      type: Object,
      required: true,
    },
  },
};
</script>
